import React,{Component} from 'react';
import {connect} from 'react-redux';
import cssClassses from './Console.css'
import ConsoleTitle from './ConsoleTitle/ConsoleTitle';
import ConsoleDisc from './ConsoleDisc/ConsoleDisc';
class Console extends Component{

    render(){
        return (
            <div className={cssClassses.Console}>
                <ConsoleTitle 
                    logo={this.props.audio.logo} 
                    name={this.props.audio.name}
                    duration={this.props.audio.duration}
                    styles={this.props.specialStyling}
                    analyser={this.props.audio.analyser}
                    dataArray={this.props.audio.dataArray}
                    artist={this.props.audio.artist}
                />
                <ConsoleDisc 
                    styles={this.props.specialStyling}
                    id={this.props.id}
                />
            </div>

        )
    }

}

const mapStateToprops = (state,ownProps)=>{
    return {
        audio:state.audios[ownProps.id]    
    }
}

const mapDispatchToProps = dispatch =>{
    return {

    }
}

export default connect(mapStateToprops,mapDispatchToProps)(Console);


